// Utilidades para links de ubicación (Waze / Google Maps) usados por el mensajero.

export function isWaze(u) {
  return /waze\.com/i.test(u || "");
}

// ¿El texto parece un link válido de mapas (Waze o Google Maps)?
export function isMapUrl(u) {
  if (!u) return false;
  return /^https?:\/\/(www\.)?(waze\.com|maps\.google\.|google\.[a-z.]+\/maps|maps\.app\.goo\.gl|goo\.gl\/maps|g\.co\/maps)/i.test(String(u).trim());
}

// Devuelve el href a abrir: el link pegado si es una URL http(s); si no, arma una búsqueda en Google Maps con la dirección.
export function mapHref(url, address) {
  const u = String(url || "").trim();
  if (/^https?:\/\//i.test(u)) return u;
  if (address) return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
  return "";
}
